/**
 * Delete Blog Post Mutation Hook
 *
 * Delete blog posts with automatic cache invalidation.
 *
 * @example
 * const { mutate, isPending } = useDeleteBlogPost();
 * mutate('post-id', { onSuccess: () => console.log('Deleted') });
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteBlogPost } from '../api';
import { blogPostsKeys } from './useBlogPosts';

/**
 * Hook to delete a blog post
 *
 * @returns Mutation object with mutate function and state
 */
export const useDeleteBlogPost = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: deleteBlogPost,
    onSuccess: () => {
      // Invalidate blog posts list to refetch
      void queryClient.invalidateQueries({ queryKey: blogPostsKeys.all });
    },
    onError: (error) => {
      console.error('Error deleting blog post:', error);
    },
  });
};
